export enum DetailTotal{
    DETAIL  =   "D",
    TOTAL   =   "T"
}